<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline"
             v-if="showHeader">
            <h4 class="text-capitalize">{{ groupCode }}s</h4>
            <button @click="newUser"
                    :disabled="loading"
                    class="btn btn-primary">
                New {{ groupCode }}
            </button>
        </div>
        <AppTable :columns="columns"
                  ref="table"
                  :rows="users"
                  :query="query"
                  @on-row-click="viewUser"
                  :loading="loading"
                  :total="total"
                  :row-class="getRowClass"
                  @on-query-change="onQueryChange">
            <template slot="table-row" slot-scope="props">
                <!-- Name -->
                <span v-if="props.column.field === 'name'">
                    {{ props.row.name }}<br>
                    <button class="btn btn-link vgt-table__btn text-nowrap"
                            :disabled="isUserAssigned(props.row.id)"
                            v-if="company"
                            @click.stop="$emit('on-assign-user', props.row)">
                        {{ isUserAssigned(props.row.id) ? 'Assigned' : 'Assign'}} as default contact
                        <i class="material-icons text-success md-18"
                           v-if="isUserAssigned(props.row.id)">check</i>
                    </button>
            </span>
                <!-- Other -->
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
            </template>
        </AppTable>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import AppTable from '../form/AppTable';

export default {
  props: {
    company: Object,
    showHeader: {
      default: true,
    },
  },
  components: {
    AppTable,
  },
  computed: {
    ...mapState({
      query: (state) => state.users.query,
      total: (state) => state.users.totalUsers,
    }),
    ...mapGetters({
      users: 'users/users',
    }),
    groupCode() {
      return this.$route.params.groupCode;
    },
    columns() {
      return [
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Email',
          field: 'email',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Phone (mobile)',
          field: 'phone_mobile',
          hidden: this.company,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Phone (office)',
          field: 'phone_office',
          filterOptions: {
            enabled: true,
          },
          hidden: this.company,
        },
        {
          label: 'Company',
          field: 'company.name',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  watch: {
    '$route.params.groupCode'() {
      this.$refs.table.reset();
      this.getUsers();
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    isUserAssigned(id) {
      return this.company.default_contact_user_id === id;
    },
    newUser() {
      this.$router.push({
        name: 'user',
        params: { id: 'new' },
      });
    },
    viewUser(event) {
      if (this.company) {
        const props = {
          id: event.row.id,
          isNewUser: false,
        };

        this.$store.dispatch('users/openUserModal', props);
      } else {
        this.$router.push({
          name: 'user',
          params: {
            groupCode: this.groupCode,
            id: event.row.id,
          },
        });
      }
    },
    getUsers() {
      this.loading = true;
      this.$store.dispatch('users/getUsers', {
        company_id: this.company ? this.company.id : null,
        group_code: this.groupCode,
      })
        .finally(() => {
          this.loading = false;
        });
    },

    onQueryChange(props) {
      this.$store.commit('users/queryProps', props);
      this.getUsers();
    },

    getRowClass(user) {
      return !user.is_activated ? '' /* 'table-secondary' */ : '';
    },
  },
};
</script>
